/* @ngInject */
function downloadMessagePublicFolderDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/download-message-public-folder/download-message-public-folder-dialog.html?$$REVISION$$',
    controller: 'DownloadMessagePublicFolderDialogController',
    controllerAs: 'vm',
    bindToController: {
      show: '='
    },
    scope: true
  }
}

export { downloadMessagePublicFolderDialogDirective }
